import React from 'react'
import PowerBreadCrumb from './PowerBreadCrumb';
import PowerGeneration from './PowerGeneration';
function PowerGenerationPage() {
    return ( 
        <div className ="container-fluid">
            <PowerBreadCrumb />
            <PowerGeneration />
        </div>
     );
}

export default PowerGenerationPage;